import type { BrandRuntimeErrorCode } from '@today/brand-config/runtime'

/** How `BrandProvider` reacts to an artifact that failed to compile (tech spec §69). */
export enum BrandFallback {
	/** Throw `BRAND_ARTIFACT_INVALID` (the default, and the production behaviour). */
	Throw = 'throw',
	/** Render the diagnostics panel instead of the children (development surfaces). */
	Diagnostics = 'diagnostics',
}

/** A brand runtime failure with a stable machine-readable code. */
export class BrandRuntimeError extends Error {
	constructor(
		readonly code: BrandRuntimeErrorCode,
		message: string,
	) {
		super(message)
		this.name = 'BrandRuntimeError'
	}
}
